import { render, staticRenderFns } from "./PlantiffPersonalInjury.vue?vue&type=template&id=514569c4&scoped=true&"
import script from "./PlantiffPersonalInjury.vue?vue&type=script&lang=ts&"
export * from "./PlantiffPersonalInjury.vue?vue&type=script&lang=ts&"
import style0 from "./PlantiffPersonalInjury.vue?vue&type=style&index=0&id=514569c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514569c4",
  null
  
)

export default component.exports